import React from 'react'
import type { DashboardStatusCategory } from '@myapp/contract'
import { DASHBOARD_CATEGORY_COLORS, DASHBOARD_CATEGORY_LABELS } from '../../../entities/dashboard'

interface Props {
  gewerke: string[]
  /** Gewerk key → name; a key without a name is shown as is. */
  gewerkLabels: Record<string, string>
  status: DashboardStatusCategory | null
  onRemoveGewerk: (key: string) => void
  onClearStatus: () => void
}

const chipClass =
  "inline-flex h-8 items-center gap-2 rounded-full border border-[#d3dceb] bg-[#E6F0FB] pl-3.5 pr-2 font-['Roboto'] text-sm font-medium text-[#124093] hover:bg-white"

export const ActiveFilterChips: React.FC<Props> = ({
  gewerke,
  gewerkLabels,
  status,
  onRemoveGewerk,
  onClearStatus,
}) => {
  if (!gewerke.length && !status) return null

  return (
    <div className="flex flex-wrap gap-2">
      {gewerke.map((key) => {
        const label = gewerkLabels[key] ?? key
        return (
          <button
            key={key}
            type="button"
            className={chipClass}
            aria-label={`Filter Gewerk ${label} entfernen`}
            onClick={() => onRemoveGewerk(key)}
          >
            Gewerk: {label}
            <span aria-hidden className="grid h-5 w-5 place-items-center text-base leading-none">
              ×
            </span>
          </button>
        )
      })}
      {status && (
        <button
          type="button"
          className={chipClass}
          aria-label={`Filter Status ${DASHBOARD_CATEGORY_LABELS[status]} entfernen`}
          onClick={onClearStatus}
        >
          <span
            aria-hidden
            className="h-2.5 w-2.5 rounded-full"
            style={{ background: DASHBOARD_CATEGORY_COLORS[status] }}
          />
          Status: {DASHBOARD_CATEGORY_LABELS[status]}
          <span aria-hidden className="grid h-5 w-5 place-items-center text-base leading-none">
            ×
          </span>
        </button>
      )}
    </div>
  )
}
